import { render, staticRenderFns } from "./ChatMember.vue?vue&type=template&id=110894b6&"
import script from "./ChatMember.vue?vue&type=script&lang=js&"
export * from "./ChatMember.vue?vue&type=script&lang=js&"
import style0 from "./ChatMember.vue?vue&type=style&index=0&id=110894b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
